import type { ReactNode } from 'react';

export function AppHeader({ children }: { children: ReactNode }) {
  return (
    <header className="app-header">
      <div className="app-header__brand">
        {/* MVP-229: the RMS wordmark, cropped from the company's own logo file (the dark
            "RMS PUBLISHING CO., LTD." line below it is unreadable on this app's dark surface). `alt=""` — the
            product name sits right next to it, so a screen reader announcing both would just
            stutter.
            MVP-276: this is the letters-only crop, not the one the login screen uses. The full mark
            leads with a star whose glow is 17% of the artwork's width and is invisible at the 24px
            the header renders it at — all it did here was push the letters 10.5px right of their own
            box, so the cluster read as shoved right and sitting low in the bar. */}
        <img className="app-header__logo" src="/logo-rms-mark.png" alt="" width={371} height={171} />
        <span className="text-subtitle">RMS Karaoke</span>
      </div>
      <div className="app-header__actions">{children}</div>
    </header>
  );
}
